module.exports = __webpack_public_path__ + "assets/img/bannoubiz-photo01.b2175aa3.jpg";